import { Component, Injector, OnInit } from '@angular/core';
import { EventsComponent } from '../events/events.component';

@Component({
	selector: 'info-we-found-mvp',
	template: `
		<div class="info-we-found-wrap">
			<h2 class="header">
				{{ control.attributes.title }}
			</h2>
			<div class="content">
				<i class="home-icon"></i>
				<p class="subtitle">
					{{ getSubtitle() }}
				</p>

				<button
					class="editpencil"
					[ngClass]="{ disabled: this.control.disabled }"
					aria-label="Info We Found Edit"
					name="{{ getNameAttribute() }}"
					(click)="onEditClick()"
					[disabled]="control.disabled"
					gtm-handler
					events="click"
					handlerType="dataValue"
					label="InfoWeFound_View_Section_Edit_Button"
					[value]="getStageName()"
					action="ButtonClick"
				>
					Edit <i class="icon-edit"></i>
				</button>
			</div>
		</div>
	`,
	styleUrls: ['./info-we-found-mvp.component.scss'],
})
export class InfoWeFoundMvpComponent extends EventsComponent implements OnInit {
	constructor(injector: Injector) {
		super(injector);
	}

	ngOnInit() {
		this.gaLabel = this.getGaLabel(this.control);
		this.firePrefillDisplay();
	}

	getSubtitle() {
		return this.storeService.getDynamicContent(`InfoWeFound.${this.control.name}`);
	}

	getNameAttribute() {
		const str = this.control.name.split('found');
		if (str.length > 1) {
			return `${str[1]}.InfoWeFound.EditButton`;
		}
		return '';
	}

	getStageName() {
		return this.storeService.getState().data.ui.page.title;
	}

	onEditClick() {
		this.ajaxAction();
		this.splunkAnalyticsService.publish('ButtonClick', 'InfoWeFound_View_Section_Edit');
	}

	firePrefillDisplay() {
		if (this.control.prefillDisplay) {
			this.splunkAnalyticsService.pushDisplayOnce(
				`InfoWeFound_View_Displayed_${this.control.prefillDisplay.join('_').replace(/PolicyData./g, '')}`
			);
		}
	}
}
